<template>
  <div style="background-color: #F9FBFD;">
    <div class="spInformation_header">
      <div class="spInformation_header_img">
        <img src="../assets/banner-1.png" alt="">
      </div>
      <div class="spInformation_header_title" id="spInformation_header_title">
        <div class="spInformation_header_box"
          :style="index == titIndex || Number(index) + 6 == titIndex  ? 'color: #1D2B3E;' : ''"
          v-for="(item,index) in titleList" :key="index" @click="handleSelect(index)">
          <span>{{item.name}}</span>
        </div>
        <div class="tab-activation-item" :style="{
          		left: (spInformationleft + 338)+'px',
          	}"></div>
        <div class="spInformation_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">Help Each Other</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">互助平台</div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 0">
      <div class="w">
        <div class="talents">
          <div class="group">
            <input placeholder="输入人才名称搜索" type="search" class="input" v-model="queryInfo1.keyName">
            <div class="input-sou el-icon-search" @click="getonlineconsultationsplist()">
              <span style="padding-left: 12px;">搜索</span>
            </div>
          </div>
          <div class="talents-teacher">
            <div class="talents-teacher-box" v-for="(item, key) in queryInfolist1" :key="key" @click="gomedicine">
              <div class="talents-teacher-box-img">
                <el-image style="width: 150px; height: 158px;" :src="item.avatar" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="talents-teacher-box-box">
                <span>{{item.spName}}</span>
                <div>
                  <!-- <span class="talents-teacher-box-box-button">武汉</span> -->
                  <span class="talents-teacher-box-box-button">{{item.companyName}}</span>
                </div>
                <span>{{item.goodCaseName}}</span>
              </div>
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total1" :page-size="queryInfo1.pageSize"
              :current-page="queryInfo1.pageNum" @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 1">
      <div class="w">
        <div class="talents">
          <div class="group">
            <input placeholder="输入教师名称搜索" type="search" class="input" v-model="queryInfo2.name">
            <div class="input-sou el-icon-search" @click="getofficialteacherslist()">
              <span style="padding-left: 12px;">搜索</span>
            </div>
          </div>
          <div class="talents-teacher">
            <div class="talents-teacher-box" v-for="(item, key) in queryInfolist2" :key="key">
              <div class="talents-teacher-box-img" v-if="item.sex === '男'">
                <img src="../assets/man.png" alt="" srcset="">
              </div>
              <div class="talents-teacher-box-img" v-if="item.sex === '女'">
                <img src="../assets/girl.png" alt="" srcset="">
              </div>
              <div class="talents-teacher-box-box">
                <span>{{item.name}}</span>
                <div>
                  <span class="talents-teacher-box-box-button">{{item.address}}</span>
                  <span class="talents-teacher-box-box-button">{{item.ageLimit}}</span>
                </div>
                <span>{{item.introduction}}</span>
              </div>
            </div>

          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total2" :page-size="queryInfo2.pageSize"
              :current-page="queryInfo2.pageNum" @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2">
            </el-pagination>
          </div>
          <!-- <div class="About-teacher">
            <div class="About-teacher-box" v-for="(item, key) in queryInfolist2" :key="key">
              <div class="About-teacher-box-img">
                <el-image style="width: 351px; height: 464px;" :src="item.faceImageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="About-teacher-box-box ql-snow ql-editor" id="editor">
                <span>{{item.name}}</span>
                <div>
                  <span class="About-teacher-box-box-button">{{item.company}}</span>
                </div>
                <span v-html="item.introduction"></span>
              </div>
            </div>

          </div> -->
          <!-- <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total2" :page-size="queryInfo2.pageSize"
              :current-page="queryInfo2.pageNum" @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2">
            </el-pagination>
          </div> -->
        </div>
      </div>
    </div>
    <div v-if="titIndex == 2">
      <div class="w">
        <div class="talents">
          <div class="group">
            <input placeholder="输入案例名称搜索" type="search" class="input" v-model="queryInfo3.nameKey">
            <div class="input-sou el-icon-search" @click="getcaseexamlist()">
              <span style="padding-left: 12px;">搜索</span>
            </div>
          </div>
          <div class="talents-case">
            <div class="talents-case-box" v-for="(item, key) in queryInfolist3" :key="key" @click="gomedicine">
              <div class="talents-case-box-img">
                <el-image style="width: 256px; height: 187px;" :src="item.imageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="talents-case-box-title">{{item.name}}</div>
              <div class="talents-case-box-box">{{item.caseDes}}</div>
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total3" :page-size="queryInfo3.pageSize"
              :current-page="queryInfo3.pageNum" @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 3">
      <div class="w">
        <div class="talents">
          <div class="group">
            <input placeholder="输入教材名称搜索" type="search" class="input" v-model="queryInfo4.name">
            <div class="input-sou el-icon-search" @click="getofficialspbooklist()">
              <span style="padding-left: 12px;">搜索</span>
            </div>
          </div>
          <div class="talents-material">
            <div class="talents-material-box" v-for="(item, key) in queryInfolist4" :key="key" @click="gomedicine">
              <div class="talents-material-box-img">
                <el-image style="width: 220px; height: 250px;" :src="item.coverImageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="talents-material-box-title">{{item.name}}</div>
            </div>

          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total4" :page-size="queryInfo4.pageSize"
              :current-page="queryInfo4.pageNum" @size-change="handleSizeChange4"
              @current-change="handleCurrentChange4">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 4">
      <div class="w">
        <div class="talents">
          <div class="group">
            <input placeholder="输入教具名称搜索" type="search" class="input" v-model="queryInfo5.name">
            <div class="input-sou el-icon-search" @click="getofficialsptoollist()">
              <span style="padding-left: 12px;">搜索</span>
            </div>
          </div>
          <div class="talents-training">
            <div class="talents-training-box" v-for="(item, key) in queryInfolist5" :key="key" @click="gomedicine">
              <div class="talents-training-box-img">
                <div class="talents-material-box-img">
                  <el-image style="width: 220px; height: 187px;" :src="item.coverImageUrl" :fit="fit">
                    <div slot="error" class="image-slot">
                      <img src="../assets/noimg.png" alt="">
                    </div>
                  </el-image>
                </div>
              </div>
              <div class="talents-training-box-title">{{item.name}}</div>
            </div>

          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total5" :page-size="queryInfo5.pageSize"
              :current-page="queryInfo5.pageNum" @size-change="handleSizeChange5"
              @current-change="handleCurrentChange5">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 5">
      <div class="w">
        <div class="talents-make">
          <div class="talents-make-title">SP预约</div>
          <div class="talents-make-box">
            <el-form ref="makeForm" :model="makeForm" :rules="makeFormRules" label-width="242px">
              <div class="login_header_box">
                <el-form-item prop="name" style="margin-bottom: 36px;" label="联系人">
                  <el-input style="position: fixed;bottom: -9999px;">
                  </el-input>
                  <el-input v-model="makeForm.name" placeholder="请输入真实姓名" style="width: 791px;">
                  </el-input>
                </el-form-item>
                <el-form-item prop="phone" style="margin-bottom: 36px;" label="联系方式">
                  <el-input style="position: fixed;bottom: -9999px;">
                  </el-input>
                  <el-input v-model="makeForm.phone" placeholder="请输入手机号码" style="width: 791px;">
                  </el-input>
                </el-form-item>
                <el-form-item prop="company" style="margin-bottom: 36px;" label="单位">
                  <el-input style="position: fixed;bottom: -9999px;">
                  </el-input>
                  <el-input v-model="makeForm.company" placeholder="请输入单位名称" style="width: 791px;">
                  </el-input>
                </el-form-item>
                <el-form-item prop="needs" style="margin-bottom: 36px;" label="需求">
                  <el-input style="position: fixed;bottom: -9999px;">
                  </el-input>
                  <el-input type="textarea" :rows="7" v-model="makeForm.needs" placeholder="请输入需求"
                    style="width: 791px;">
                  </el-input>
                </el-form-item>

                <div style="width: 100%;display: flex;justify-content: center;">
                  <div class="btns" @click="Forget('makeForm')">
                    提交信息
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        fit: 'fill',
        titleList: [{
            name: 'SP人才库',
            value: 0
          },
          {
            name: 'SP师资库',
            value: 1
          },
          {
            name: 'SP案例库',
            value: 2
          },
          {
            name: 'SP教材库',
            value: 3
          },
          {
            name: 'SP教具库',
            value: 4
          },
          {
            name: 'SP预约',
            value: 5
          }
        ],
        titIndex: 0,
        spInformationwidth: 0,
        spInformationheight: 4,
        spInformationleft: 0,
        makeForm: {
          name: '',
          phone: '',
          company: '',
          needs: ''
        },
        makeFormRules: {
          name: [{
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }],
          company: [{
            required: true,
            message: '请输入单位',
            trigger: 'blur'
          }],
          needs: [{
            required: true,
            message: '请输入需求',
            trigger: 'blur'
          }],
        },
        queryInfo1: {
          pageNum: 1,
          pageSize: 10,
          keyName: '',
          cpyId: 35
        },
        queryInfo2: {
          pageNum: 1,
          pageSize: 10,
          name: '',
          type: 2
        },
        queryInfo3: {
          pageNum: 1,
          pageSize: 9,
          nameKey: '',
          cpyId: 0
        },
        queryInfo4: {
          pageNum: 1,
          pageSize: 9,
          name: ''
        },
        queryInfo5: {
          pageNum: 1,
          pageSize: 9,
          name: ''
        },
        queryInfolist1: [],
        total1: 0,
        queryInfolist2: [],
        total2: 0,
        queryInfolist3: [],
        total3: 0,
        queryInfolist4: [],
        total4: 0,
        queryInfolist5: [],
        total5: 0,

      }
    },
    watch: {
      titIndex(newVal) {
        this.titIndex = newVal
        this.$nextTick(() => {
          this.init()
        })
        if (this.titIndex == 0) {
          this.getonlineconsultationsplist()
        } else if (this.titIndex == 1) {
          this.getofficialteacherslist()
        } else if (this.titIndex == 2) {
          this.getcaseexamlist()
        } else if (this.titIndex == 3) {
          this.getofficialspbooklist()
        } else if (this.titIndex == 4) {
          this.getofficialsptoollist()
        }
      }
    },
    mounted() {

    },
    created() {
      if (this.$route.query.place) {
        this.titIndex = this.$route.query.place
      } else {
        this.titIndex = 0
        this.getonlineconsultationsplist()
      }

    },
    methods: {
      gomedicine() {
        window.open('https://zjh.zhihuiyijiao.com/', '_blank')
      },
      handleSizeChange1(newSize) {
        this.queryInfo1.pageSize = newSize
        this.getonlineconsultationsplist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange1(newPage) {
        this.queryInfo1.pageNum = newPage
        this.getonlineconsultationsplist()
      },
      handleSizeChange2(newSize) {
        this.queryInfo2.pageSize = newSize
        this.getofficialteacherslist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange2(newPage) {
        this.queryInfo2.pageNum = newPage
        this.getofficialteacherslist()
      },
      handleSizeChange3(newSize) {
        this.queryInfo3.pageSize = newSize
        this.getcaseexamlist()
      },

      // 监听 页码值 改变的事件
      handleCurrentChange3(newPage) {
        this.queryInfo3.pageNum = newPage
        this.getcaseexamlist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange4(newPage) {
        this.queryInfo4.pageNum = newPage
        this.getofficialspbooklist()
      },
      handleSizeChange4(newSize) {
        this.queryInfo4.pageSize = newSize
        this.getofficialspbooklist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange5(newPage) {
        this.queryInfo5.pageNum = newPage
        this.getofficialsptoollist()
      },
      handleSizeChange5(newSize) {
        this.queryInfo5.pageSize = newSize
        this.getofficialsptoollist()
      },
      async getonlineconsultationsplist() {

        let res = await this.$Http.onlineconsultationsplist(this.queryInfo1)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist1 = res.data.data.list
        this.total1 = res.data.data.total
      },
      async getofficialteacherslist() {
        let res = await this.$Http.officialteacherslist(this.queryInfo2)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist2 = res.data.data.list
        this.total2 = res.data.data.total
      },
      async getcaseexamlist() {

        let res = await this.$Http.caseexamlist(this.queryInfo3)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist3 = res.data.data.list
        this.total3 = res.data.data.total
      },
      async getofficialspbooklist() {

        let res = await this.$Http.officialspbooklist(this.queryInfo4)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist4 = res.data.data.list
        this.total4 = res.data.data.total
      },
      async getofficialsptoollist() {

        let res = await this.$Http.officialsptoollist(this.queryInfo5)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist5 = res.data.data.list
        this.total5 = res.data.data.total
      },
      Forget() {
        this.$refs.makeForm.validate(async valid => {
          if (!valid) return
          let res = await this.$Http.officialsparrangesave(this.makeForm)
          if (res.data.result != 0) {
            this.$message.error(res.data.msg)
            return
          }
          this.$message.success('提交成功')
          this.makeForm.name = ''
          this.makeForm.phone = ''
          this.makeForm.company = ''
          this.makeForm.needs = ''
        })
      },
      handleSelect(index) {
        this.titIndex = index
        this.$router.push({
          query: {
            place: this.titIndex
          }
        })
      },
      init() {
        let data = document.getElementsByClassName('spInformation_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 5) {
            this.spInformationwidth = arr[Number(this.titIndex) - 6]
            titIndexnum = Number(this.titIndex) - 6
          } else {
            this.spInformationwidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }
          this.spInformationleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('spInformation_header_title').scrollLeft = this.spInformationleft - arr[this
            .titIndex] / 2;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
  }

  .spInformation_header {
    width: 100%;
    position: relative;
  }

  .spInformation_header_img {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .spInformation_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .spInformation_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .spInformation_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .talents {
    width: 100%;
    margin-top: 80px;
  }

  .group {
    display: flex;
    line-height: 28px;
    align-items: center;
    position: relative;
    max-width: 1128px;
    margin: 0 auto;
  }

  .input {
    width: 100%;
    height: 60px;
    line-height: 28px;
    padding: 0 1rem;
    padding-left: 2.5rem;
    padding-right: 140px;
    border: 2px solid transparent;
    border-radius: 8px;
    outline: none;
    // background-color: #f3f3f4;
    // background-color: rgba(26, 123, 252, 0.4);
    // box-shadow: 0 0 0 4px rgb(26 123 252 / 10%);
    border-color: rgba(26, 123, 252, 0.4);
    background-color: rgb(249, 251, 253);
    color: #0d0c22;
    transition: .3s ease;
    font-size: 20px;
  }

  .input::placeholder {
    font-size: 20px;
    color: #9e9ea7;
  }

  .input:focus,
  input:hover {
    outline: none;
    border-color: rgba(26, 123, 252, 0.4);
    background-color: #fff;
    box-shadow: 0 0 0 4px rgb(26 123 252 / 10%);
  }

  .icon {
    position: absolute;
    left: 1rem;
    fill: #9e9ea7;
    width: 1rem;
    height: 1rem;
  }

  .input-sou {
    position: absolute;
    right: 4px;
    fill: #9e9ea7;
    width: 120px;
    height: 52px;
    background-color: #1A7BFC;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .talents-teacher {
    width: 100%;
    height: 100%;
    padding: 40px 36px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .talents-teacher-box {
    padding: 24px;
    width: 546px;
    height: 206px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    margin-right: 36px;
    margin-bottom: 36px;
    float: left;
    display: flex;
    cursor: pointer;
  }

  .talents-teacher-box:nth-child(2n) {
    margin-right: 0;
  }

  .talents-teacher-box-img {
    width: 150px;
    height: 158px;
    overflow: hidden;

    image {
      width: 100%;
      height: 100%;
    }

    // background-color: #AEB7C2;
  }

  .talents-teacher-box-box {
    width: 324px;
    margin-left: 24px;
    padding: 11px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .talents-teacher-box-box span:nth-child(1) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 16px;
    font-weight: normal;
    color: #395172;
  }

  .talents-teacher-box-box-button {
    display: inline-block;
    padding: 2px 5px;
    background: rgba(134, 147, 164, 0.1);
    font-size: 12px !important;
    border-radius: 2px;
    margin-right: 11px;
    background: rgba(26, 123, 252, 0.2);
    color: #1A7BFC !important;
  }

  .talents-teacher-box-box span:nth-child(3) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 14px;
    font-weight: normal;
    color: #8693A4;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .news-footer {
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    text-align: center;
  }

  .talents-case {
    width: 100%;
    height: 100%;
    padding: 40px 36px;
    overflow: hidden;
    box-sizing: border-box;

  }

  .talents-case-box {
    padding: 24px 48px;
    width: 352px;
    height: 325px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-right: 36px;
    margin-bottom: 36px;
    cursor: pointer;
  }

  .talents-case-box:nth-child(3n) {
    margin-right: 0;
  }

  .talents-case-box-img {
    width: 256px;
    height: 187px;
  }

  .talents-case-box-title {
    font-size: 16px;
    font-weight: #395172;
    font-weight: 600;
  }

  .talents-case-box-box {
    width: 100%;
    font-size: 14px;
    font-weight: #8693A4;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .talents-material {
    width: 100%;
    height: 100%;
    padding: 40px 36px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .talents-material-box {
    padding: 24px;
    width: 352px;
    height: 346px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-right: 36px;
    margin-bottom: 36px;
    cursor: pointer;
  }

  .talents-material-box:nth-child(3n) {
    margin-right: 0;
  }

  .talents-material-box-img {
    width: 220px;
    height: 250px;
  }

  .talents-material-box-title {
    width: 275px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #395172;
  }

  .talents-training {
    width: 100%;
    height: 100%;
    padding: 40px 36px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .talents-training-box {
    padding: 24px 48px;
    width: 352px;
    height: 283px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-right: 36px;
    margin-bottom: 36px;
    cursor: pointer;
  }

  .talents-training-box:nth-child(3n) {
    margin-right: 0;
  }

  .talents-training-box-img {
    width: 220px;
    height: 187px;
  }

  .talents-training-box-title {
    width: 275px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #395172;
  }

  .talents-make-title {
    margin-top: 50px;
    font-size: 24px;
    font-weight: 600;
    color: #1D2B3E;
    width: 100%;
    text-align: center;
  }

  .talents-make {
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    background-color: #FFFFFF;
    margin: 40px 0;

  }

  .login_header_box {
    margin: 40px 0 50px;
  }

  .login_header_box /deep/ .el-form-item__label:before {
    display: none !important;
  }

  .btns {
    display: inline-block;
    padding: 13px 39px;
    color: #FFFFFF;
    font-size: 14px;
    box-sizing: border-box;
    background: #1A7BFC;
    margin: 0 auto;
    cursor: pointer;
  }

  /deep/ .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 128px;
    }
  }


  .About-teacher {
    width: 100%;
    height: 100%;
    padding: 80px 0;
    overflow: hidden;
    box-sizing: border-box;
  }

  .About-teacher-box {
    width: 1200px;
    // height: 206px;
    box-sizing: border-box;

    display: flex;
    margin-bottom: 80px;
    flex-direction: row;
  }

  .About-teacher-box:nth-child(2n) {
    flex-direction: row-reverse;
  }

  .About-teacher-box:nth-child(2n) {
    margin-right: 0;
  }

  .About-teacher-box-img {
    width: 351px;
    height: 464px;

    image {
      width: 100%;
      height: 100%;
    }
  }

  .About-teacher-box-box {
    width: 849px;
    height: 428px;
    padding: 40px 50px;
    margin-top: 36px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #FFFFFF;
    line-height: 24px;
    position: relative;
  }

  .About-teacher-box-box span:nth-child(1) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 32px;
    font-weight: normal;
    color: #395172;
  }

  .About-teacher-box-box-button {
    display: inline-block;
    padding: 2px 5px;
    background: rgba(134, 147, 164, 0.1);
    font-size: 12px !important;
    border-radius: 2px;
    margin-right: 11px;
    background: rgba(26, 123, 252, 0.2);
    color: #1A7BFC !important;
  }

  .About-teacher-box-box span:nth-child(3) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 14px;
    font-weight: normal;
    color: #8693A4;
    // overflow: hidden;
    // -webkit-line-clamp: 3;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
  }

  .About-teacher-box-box span:nth-child(4) {
    position: absolute;
    top: 52px;
    right: 50px;
    font-size: 60px;
    color: #395172;
    opacity: 0.1;
    font-weight: 600;
  }
</style>
